import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, LineChart, Sparkles, Users, Trophy } from "lucide-react";
import { T } from "@/lib/testIds";
import { cn } from "@/lib/utils";

const items = [
  { to: "/", icon: Home, label: "Home", tid: T.navHome, end: true },
  { to: "/players", icon: LineChart, label: "Players", tid: T.navPlayers },
  { to: "/ask", icon: Sparkles, label: "Ask FPL", tid: T.navAskFpl, center: true },
  { to: "/my-team", icon: Users, label: "My Team", tid: T.navMyTeam },
  { to: "/leagues", icon: Trophy, label: "Leagues", tid: T.navLeagues },
];

export default function BottomNav() {
  const loc = useLocation();
  if (loc.pathname === "/login") return null;

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 border-t border-totem-border bg-totem-bg/85 backdrop-blur-md"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="mx-auto max-w-md px-2 pt-2 pb-2">
        <ul className="grid grid-cols-5 items-end gap-1">
          {items.map(({ to, icon: Icon, label, tid, center, end }) => (
            <li key={to} className="flex justify-center">
              <NavLink
                to={to}
                end={end}
                data-testid={tid}
                className={({ isActive }) =>
                  cn(
                    "flex flex-col items-center gap-1 py-1 px-2 rounded-lg transition-colors",
                    !center && (isActive ? "text-totem-green" : "text-totem-textDim"),
                    center && "relative -mt-6"
                  )
                }
              >
                {({ isActive }) =>
                  center ? (
                    <div className="flex flex-col items-center gap-1">
                      <span
                        className={cn(
                          "grid place-items-center w-14 h-14 rounded-full ai-glow animate-pulse-ring",
                          isActive ? "bg-totem-gold" : "bg-totem-gold"
                        )}
                        style={{
                          boxShadow: isActive
                            ? "0 0 32px rgba(227,195,43,0.65), 0 0 4px rgba(227,195,43,0.9) inset"
                            : undefined,
                        }}
                      >
                        <Sparkles size={26} className="text-totem-bg" strokeWidth={2.5} />
                      </span>
                      <span className="mono text-[10px] uppercase tracking-wider text-totem-gold">
                        {label}
                      </span>
                    </div>
                  ) : (
                    <>
                      <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                      <span className="mono text-[10px] uppercase tracking-wider">{label}</span>
                    </>
                  )
                }
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
